(function (window) {
	"use strict";
	function defineRoundingValueHelper() {
		var roundingValueHelper = {};
		roundingValueHelper.roundUp = function(value, decimalPlaces){
			var number = Number(value);
			if(number){
				return number.toFixed(decimalPlaces);
			}
			return "0";
		};
        
		return roundingValueHelper;
	}
	//define globally if it doesn't already exist
	if (typeof (roundingValueHelper) === "undefined") {
		window.roundingValueHelper = defineRoundingValueHelper();
	} else {
		console.log("roundingValueHelper already defined.");
	}
})(window);